export default {
  headerId: 'header',
  footerId: 'footer'
};
